import { Action, createAction } from 'redux-act';

import ReservationSetting from '../../../models/interfaces/ReservationSetting';
import TimestampPayload from '../TimestampPayload';

export interface SaveReservationSettingPayload extends TimestampPayload {
  reservationSetting: ReservationSetting;
}
export const saveReservationSetting = createAction<SaveReservationSettingPayload>('SAVE_RESERVATION_SETTING');
export type SaveReservationSettingActionType = Action<SaveReservationSettingPayload>;
export interface ReservationSettingSavedPayload extends TimestampPayload {
  reservationSetting: ReservationSetting;
}
export const reservationSettingSaved = createAction<ReservationSettingSavedPayload>('RESERVATION_SETTING_SAVED');

interface ReservationSettingSaveFailedPayload extends TimestampPayload {
  placeUuid: string;
  reservationSettingUuid: string;
}
export const reservationSettingSaveFailed = createAction<ReservationSettingSaveFailedPayload>('RESERVATION_SETTING_SAVE_FAILED');
